/**
 * Path constants for api requests
 */
export default {

  // Auth
  LOGIN_PATH: "/user/login",
  REFRESH_TOKEN_PATH: "/user/refresh",
  GET_USER_INFO_PATH: "/user/self",

  // Password reset (in-house flow, replaces the Microsoft-hosted B2C reset page)
  REQUEST_PASSWORD_RESET_PATH: "/user/password/reset/request",
  CONFIRM_PASSWORD_RESET_PATH: "/user/password/reset/confirm",

  // Password setup for newly invited portal users (anonymous, token comes from the invitation mail)
  CONFIRM_PASSWORD_SETUP_PATH: "/user/password/setup/confirm",

  // MFA
  MFA_VERIFY_PATH: "/mfa/verify",
  MFA_RESEND_PATH: "/mfa/resend",

  // DISPLAY_AD
  DISPLAY_AD_PATH: "/contentarea",
  PREVIEW_DISPLAY_AD_PATH: "/contentarea/preview",
  WORKFLOW_PATH: "/contentarea/workflow",

  // STORE
  STORE_PATH: "/store",
  STORE_ICON_APPEND_PATH: "/icon",

  // CONTACT_EMAIL
  SEND_EMAIL: "/contactemail/send",

  // COMPANY_STRUCTURE
  CS_GET_CHILDREN_PATH: "/companystructure/stores",
  COMPANY_STRUCTURE_GET_RIGHTS_PATH: "/companystructure/rights",
  COMPANY_STRUCTURE_GET_PARENT_RIGHTS_PATH: "/companystructure/parent/rights",

  // DATA_ANALYTICS
  DATA_ANALYTICS_BY_QUERY_PATH: "/v1/analytics/data",
  DATA_ANALYTICS_USER_PATH: "/v1/analytics/user",
  STATISTICS_ENV_CERT_PATH: "/statistics/envcert",

  // PRICING
  PRICING_PATH: "/pricing",
  PRICING_CUSTOM_PATH: "/pricing/custom",
  PRICING_REFERENCE: "/pricing/reference/standard",

  // CUSTOMER
  CUSTOMER_POS_PATH: "/customer/pos",
  CUSTOMER_DISTRI_PATH: "/customer/distributor",
  CUSTOMER_NEWSLETTER_PATH: "/customer/newsletter-register-success",
  CUSTOMER_VENDOR_APPLY_PATH: "/customer/vendor/apply",
  CUSTOMER_VENDOR_ACTIVATE_PATH_PREPEND: "/customer/vendor/",
  CUSTOMER_VENDOR_ACTIVATE_PATH_APPEND: "/activate",

  // CUSTOMER MANAGEMENT
  DISTRIBUTOR_CUSTOMER_PATH: "/distributorcustomer/customer",
  DISTRIBUTOR_CUSTOMER_INVITE_PATH: "/distributorcustomer/customer/invite",
  DISTRIBUTOR_INVITED_PATH: "/distributorcustomer/customer/invited",

  POS_CUSTOMER_PATH: "/possoftwarecustomer/customer",
  POS_CUSTOMER_INVITED_PATH: "/possoftwarecustomer/customer/invited",
  POS_CUSTOMER_DISTRI_INVITE_PATH: "/possoftwarecustomer/distributor/invite",

  // CUSTOMER MODULES
  CUSTOMER_MODULES_PATH: "/customermodules",

  // VENDOR CUSTOMER
  VENDOR_CUSTOMER_PREPEND_PATH: "/vendorcustomer/",
  VENDOR_CUSTOMER_STORES_APPEND_PATH: "/store",
  VENDOR_CUSTOMER_API_USERS_APPEND_PATH: "/vendorusers",
  VENDOR_CUSTOMER_ICON_APPEND_PATH: "/icon",

};
